/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface OrderChangeRequisite {
  depositNumber: string;

  /** @pattern ^\d+$ */
  accountNumber?: string;
  clientName?: string;

  /** @pattern ^\d+$ */
  bic?: string;

  /** @pattern ^\d+$ */
  anotherAccountNumber?: string;
}

export interface OrderChangeRequisiteResponse {
  /** @format uuid */
  id?: string;
  number?: string;

  /** @format date */
  createDate?: string;
  status?:
    | "NEW"
    | "AWAITING_RATE"
    | "ERROR_AWAITING_RATE"
    | "RATE_SET"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "NO_SIGNATURES"
    | "OUT_OF_DATE"
    | "SENT_ERROR"
    | "IN_PROCESS"
    | "ACCEPTED"
    | "REJECTED"
    | "AWAITING_PAYMENT"
    | "COMPLETED";
  statusText?: string;
  rejectReason?: string;
  depositContractNumber?: string;

  /** @format date */
  depositOpenDate?: string;
  depositSum?: number;
  depositCurrency?: string;
  depositProduct?: string;
  accountNumber?: string;
  clientName?: string;
  bic?: string;
  kpp?: string;
  anotherAccountNumber?: string;

  /** Список подписантов для статуса "Частично подписан" */
  signatories?: Signatories[];
}

/**
 * Информация о подписанте
 */
export interface Signatories {
  /** Полное имя */
  fullName?: string;

  /** userExtId из jwt токена */
  userId?: string;

  /** Позиция */
  position?: string;

  /**
   * Дата подписи
   * @format date-time
   */
  signDate?: string;
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

export interface OrderChangeRequisiteUpdate {
  /** @pattern ^\d+$ */
  accountNumber?: string;
  clientName?: string;

  /** @pattern ^\d+$ */
  bic?: string;

  /** @pattern ^\d+$ */
  anotherAccountNumber?: string;
}

/**
 * Запрос подбора депозита по введенным данным
 */
export interface DepositProductPickerRequest {
  /** Частичное пополнение */
  isPartIncrement?: boolean;

  /** Частичное снятие */
  isPartDecrement?: boolean;

  /**
   * Срок размещения
   * @format int32
   */
  period?: number;

  /** Сумма к размещению */
  amount?: number;
}

/**
 * Получение депозитных продуктов по параметрам
 */
export interface DepositProductPickerResponse {
  /** Депозитные продукты */
  products?: string[];
}

/**
 * Создание новой заявки на депозит
 */
export interface OrderDepositRequest {
  /** Код депозитного продукта */
  productCode: string;

  /**
   * Сумма депозита к размещению
   * @min 1
   */
  amountMoney: number;

  /** Буквенный код валюты */
  currency: string;

  /**
   * Срок размещения
   * @format int64
   * @min 1
   */
  period: number;

  /** Периодичность выплаты процентов */
  paymentType: "TERM_END" | "MONTHLY";

  /**
   * Счет для списания
   * @pattern ^\d+$
   */
  withdrawAccountNumber?: string;

  /**
   * Счет для зачисления
   * @pattern ^\d+$
   */
  receivingAccountNumber?: string;

  /** Ставка из массива ставок public-rate */
  rate?: number;

  /** Система инициатор создания заявки */
  initiator?: "WEB" | "MOBILE";

  /** Признак зачисления на счет в другом банке */
  isTransferToExternalAccount?: boolean;

  /** Признак открытия депозита без расчетного счета */
  isDepositWithoutRko?: boolean;

  /**
   * Счет в другом банке
   * @pattern ^\d+$
   */
  externalAccount?: string;

  /**
   * БИК другого банка
   * @pattern ^\d+$
   */
  externalBicBank?: string;

  /** Название организации в другом банке */
  organizationNameInAnotherBank?: string;

  /** Признак зачисления средств со счета в другом банке */
  isDepositTransferFromAnotherBankAccount?: boolean;
}

/**
 * Создание новой заявки на депозит
 */
export interface OrderDepositResponse {
  /**
   * Идентификатор заявки на депозит
   * @format uuid
   */
  orderDepositId?: string;

  /** Статус заявки на депозит */
  status?:
    | "NEW"
    | "AWAITING_RATE"
    | "ERROR_AWAITING_RATE"
    | "RATE_SET"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "NO_SIGNATURES"
    | "OUT_OF_DATE"
    | "SENT_ERROR"
    | "IN_PROCESS"
    | "ACCEPTED"
    | "REJECTED"
    | "AWAITING_PAYMENT"
    | "COMPLETED";
}

/**
 * Создание новой заявки на НСО
 */
export interface OrderBalanceRequest {
  /**
   * Счет НСО
   * @pattern ^\d+$
   */
  account: string;

  /** Буквенный код валюты */
  currency: string;

  /** Сумма неснижаемого остатка */
  minBalanceAmount?: number;

  /** Код депозитного продукта */
  productCode: string;

  /**
   * Срок договора
   * @format int32
   */
  period: number;

  /** Система инициатор создания заявки  */
  initiator?: "WEB" | "MOBILE";
}

export interface OrderBalanceResponse {
  /**
   * Идентификатор заявки на НСО
   * @format uuid
   */
  id?: string;

  /** Статус заявки на НСО */
  status?: string;
}

/**
 * Получение депозитов
 */
export interface Deposit {
  /** Идентификатоор депозита */
  id?: string;

  /** Наименование депозитного продукта */
  productName?: string;

  /** Номер договора депозита */
  agreementNumber?: string;

  /**
   * Дата открытия депозита
   * @format date
   */
  openDate?: string;

  /** Сумма депозита */
  restAmountMoney?: number;

  /** Валюта депозита */
  currency?: string;

  /** Процентная ставка по депозиту */
  percent?: number;

  /**
   * Дата окончания депозита
   * @format date
   */
  endDate?: string;

  /**
   * Дата фактического закрытия депозита
   * @format date
   */
  closeDate?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate?: string;

  /** Депозитный счет */
  accountNumber?: string;

  /** Общее количество начисленных процентов */
  income?: number;

  /** Начисленные проценты по датам */
  depositPayments?: DepositPercentagePayment[];
}

/**
 * Данные по доходности
 */
export interface DepositPercentagePayment {
  /**
   * Дата начисления процентов
   * @format date
   */
  paymentDate?: string;

  /** Сумма начисленных процентов */
  percentAmount?: number;
}

export interface PageMetadata {
  /** @format int64 */
  size?: number;

  /** @format int64 */
  number?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int64 */
  totalPages?: number;
}

export interface PagedModelDeposit {
  content?: Deposit[];
  page?: PageMetadata;
}

export interface AvailableBusinessOperationsResponse {
  availableOperations?: string[];
}

export interface PagedModelOrderChangeRequisiteResponse {
  content?: OrderChangeRequisiteResponse[];
  page?: PageMetadata;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: OrderDocument;
}

/**
 * Документ
 */
export interface OrderDocument {
  /** Тип документа */
  type?: DocumentType;

  /** Документ */
  fields?: OrderDocument;
}

/**
 * Продукт НСО / ФО
 */
export interface BalanceProduct {
  /** Идентификатор */
  id?: string;

  /** Наименование продукта */
  name?: string;

  /** Описание продукта */
  description?: string;

  /** Условия */
  terms?: string[];

  /** Проценты для каждой валюты */
  percentCurrencies?: PercentCurrency[];

  /** Сроки размещения для каждой валюты */
  placementRanges?: PlacementRange[];
}

/**
 * Депозитный продукт
 */
export interface DepositProduct {
  /** Идентификатор */
  id?: string;

  /** Наименование депозита */
  name?: string;

  /** Описание депозита */
  description?: string;

  /** Частичное снятие */
  isPartDecrement?: boolean;

  /** Частичное пополнение */
  isPartIncrement?: boolean;

  /** Условия для депозитных продуктов */
  terms?: string[];

  /** Сроки размещения для каждой валюты */
  placementRanges?: PlacementRange[];

  /** Диапазоны сумм размещения для каждой валюты */
  moneyRanges?: MoneyRange[];

  /** Проценты по депозиту для каждой валюты */
  percentCurrencies?: PercentCurrency[];
}

/**
 * Валюты и диапазоны сумм
 */
export interface MoneyRange {
  /** Валюта */
  currency?: string;

  /** Минимальная сумма */
  minAmountMoney?: number;

  /** Максимальная сумма */
  maxAmountMoney?: number;
}

/**
 * Валюты и проценты
 */
export interface PercentCurrency {
  /** Валюта */
  currency?: string;

  /**
   * Процентная ставка
   * @format double
   */
  percent?: number;
}

/**
 * Валюты и диапазоны дней размещения
 */
export interface PlacementRange {
  /** Валюта */
  currency?: string;

  /**
   * Минимальный срок размещения
   * @format int64
   */
  minPeriod?: number;

  /**
   * Максимальный срок размещения
   * @format int64
   */
  maxPeriod?: number;
}

/**
 * Список депозитных и балансовых продуктов
 */
export interface ProductList {
  /** Массив депозитных продуктов */
  depositProducts?: DepositProduct[];

  /** Массив продуктов для размещения на счетах клиентов */
  balanceProducts?: BalanceProduct[];
}

/**
 * Подробная информация по заявке на депозит
 */
export interface OrderDeposit {
  /**
   * Идентификатор депозита
   * @format uuid
   */
  id?: string;

  /** Код продукта */
  productCode?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  createDate?: string;

  /** Название продукта */
  productName?: string;

  /** Периодичность выплаты процентов */
  paymentType?: "TERM_END" | "MONTHLY";

  /** Счет для зачисления */
  receivingAccountNumber?: string;

  /** Сумма депозита к размещению */
  amountMoney?: number;

  /** Буквенный код валюты */
  currency?: string;

  /** Ставка */
  percent?: number;

  /** Статус заявки на депозит */
  status?:
    | "NEW"
    | "AWAITING_RATE"
    | "ERROR_AWAITING_RATE"
    | "RATE_SET"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "NO_SIGNATURES"
    | "OUT_OF_DATE"
    | "SENT_ERROR"
    | "IN_PROCESS"
    | "ACCEPTED"
    | "REJECTED"
    | "AWAITING_PAYMENT"
    | "COMPLETED";

  /** Описание статуса заявки на депозит */
  statusText?: string;

  /** Причина отклонения заявки */
  rejectReason?: string;

  /** Счет для списания */
  withdrawAccountNumber?: string;

  /**
   * Срок размещения
   * @format int64
   */
  period?: number;

  /** Частичное пополнение */
  isPartIncrement?: boolean;

  /** Частичное снятие */
  isPartDecrement?: boolean;

  /** Список подписантов */
  signatoriesList?: Signatories[];

  /**
   * Фактическая дата размещения депозита
   * @format date
   */
  openDate?: string;

  /** Номер депозитного счета */
  accountNumber?: string;

  /** Признак зачисления на счет в другом банке */
  isTransferToExternalAccount?: boolean;

  /** Признак открытия депозита без расчетного счета */
  isDepositWithoutRko?: boolean;

  /** Счет в другом банке */
  externalAccount?: string;

  /** БИК другого банка */
  externalBicBank?: string;

  /** Название организации в другом банке */
  organizationNameInAnotherBank?: string;

  /** Признак зачисления средств со счета в другом банке */
  isDepositTransferFromAnotherBankAccount?: boolean;
}

export interface Currency {
  currency?: string;
  paymentPeriods?: PaymentPeriod[];
}

export interface ExchangeRates {
  usd?: number;
  eur?: number;
}

export interface PaymentPeriod {
  paymentPeriod?: string;
  sumList?: Sum[];
}

export interface Product {
  product?: string;
  daySum?: number;
  currencies?: Currency[];
}

/**
 * Ставка для диапазона
 */
export interface Rate {
  isWhiteList?: boolean;
  sspZone?: string;
  exchangeRates?: ExchangeRates;

  /** Общая сумма сделок клиента по депозитам */
  allDealSumm?: number;
  products?: Product[];
}

export interface Sum {
  sumMin?: string;
  sumMax?: string;
  totalAmountList?: TotalAmount[];
}

export interface TotalAmount {
  /** @format int32 */
  dayMin?: number;

  /** @format int32 */
  dayMax?: number;
  rate?: number;
}

/**
 * Получение истории смены статусов
 */
export interface OrderStatusHistory {
  /**
   * Идентификатор записи в истории
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор объекта
   * @format uuid
   */
  orderDepositId?: string;

  /**
   * Дата смены статуса
   * @format date-time
   */
  changeDateTime?: string;

  /** Старый статус */
  oldStatus?: string;

  /** Новый статус */
  newStatus?: string;

  /** Описание старого статуса заявки */
  oldStatusText?: string;

  /** Описание нового статуса заявки */
  newStatusText?: string;
}

/**
 * Проверка наличия ЕСД
 */
export interface ClientData {
  /** Наличие ЕСД у клиента */
  hasEsd?: boolean;

  /** Краткое наименование организации */
  shortClientName?: string;

  /** Статус текущего дня (рабочий / выходной) */
  workingDate?: WorkingDate;

  /** Признак отсутствия у клиента счета */
  isDepositWithoutRko?: boolean;
}

/**
 * Статус текущего дня (рабочий / выходной)
 */
export interface WorkingDate {
  /** True, если текущий день выходной */
  isDayOff?: boolean;

  /**
   * Дата следующего рабочего дня
   * @format date
   */
  nextWorkingDay?: string;
}

/**
 * Получение детальной информации о депозите
 */
export interface DepositDetailInfo {
  /** Идентификатоор депозита */
  id?: string;

  /** Наименование депозитного продукта */
  productName?: string;

  /** Номер договора депозита */
  agreementNumber?: string;

  /**
   * Дата открытия депозита
   * @format date
   */
  openDate?: string;

  /** Сумма депозита */
  restAmountMoney?: number;

  /** Валюта депозита */
  currency?: string;

  /** Процентная ставка по депозиту */
  percent?: number;

  /**
   * Дата окончания депозита
   * @format date
   */
  endDate?: string;

  /**
   * Дата фактического закрытия депозита
   * @format date
   */
  closeDate?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate?: string;

  /** Депозитный счет */
  accountNumber?: string;

  /** Общее количество начисленных процентов */
  income?: number;

  /** Начисленные проценты по датам */
  depositPayments?: DepositPercentagePayment[];

  /** Имя клиента */
  clientName?: string;

  /** Описание типа контракта */
  contractTypeDescription?: string;

  /**
   * Дата договора
   * @format date
   */
  contractDate?: string;

  /** Неснижаемый остаток */
  irreducibleAmountMoney?: number;

  /** Порядок уплаты процентов */
  paymentType?: string;

  /** Счет для перечисления суммы депозита */
  returnDepositAccountNumber?: string;

  /** Счет для перечисления суммы процентов */
  returnPercentAccountNumber?: string;

  /** Максимальная сумма по депозиту */
  maxAmountMoney?: number;

  /** Возможность пополнения */
  isPartIncrement?: boolean;

  /** Возможность расходных операций */
  isPartDecrement?: boolean;

  /** Номер договора (ЕСД или ДОУ) */
  contractNumber?: string;

  /**
   * Дата отрытия депозитного счета
   * @format date
   */
  accountOpenDate?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

/**
 * Подробная информация по заявке на НСО/ФО
 */
export interface OrderBalance {
  /**
   * Идентификатор заявки на НСО/ФО
   * @format uuid
   */
  id?: string;

  /** Номер продукта */
  productCode?: string;

  /** Название продукта */
  productName?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  createDate?: string;

  /** Буквенный код валюты */
  currency?: string;

  /** Номер счёта */
  accountNumber?: string;

  /** Сумма неснижаемого остатка */
  minBalanceAmount?: number;

  /**
   * Срок договора
   * @format int32
   */
  period?: number;

  /** Статус заявки на НСО */
  status?: string;

  /** Текст статуса заявки на НСО/ФО */
  statusText?: string;

  /** Причина отклонения заявки */
  rejectReason?: string;

  /** Ставка */
  rate?: number;
}

/**
 * Информация о счете пользователя
 */
export interface Account {
  /** Тип */
  type?: string;

  /** Номер счета */
  number?: string;

  /** Баланс */
  amountMoney?: number;

  /** Код валюты */
  currency?: string;

  /** Статус */
  status?: "OPEN" | "CLOSE" | "BLOCK";

  /**
   * Дата открытия
   * @format date
   */
  openDate?: string;

  /**
   * Дата закрытия
   * @format date
   */
  closeDate?: string;

  /** Наличие НСО у счета */
  isMBR?: boolean;

  /** Наличие ФО у счета */
  isABR?: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис deposits
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Депозиты <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=44486754)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name GetOrderChangeRequisiteList
     * @summary Список заявок на изменение реквизитов
     * @request GET:/api/deposits/v1/external/requisite/order
     * @secure
     */
    getOrderChangeRequisiteList: (
      query?: {
        depositNumber?: string;
        openDateFrom?: string;
        openDateTo?: string;
        amountFrom?: number;
        amountTo?: number;
        currency?: string;
        product?: string;
        status?: string;
        page?: number;
        size?: number;
        sort?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PagedModelOrderChangeRequisiteResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name CreateOrderChangeRequisite
     * @summary Создание новой заявки на изменение реквизитов
     * @request POST:/api/deposits/v1/external/requisite/order
     * @secure
     */
    createOrderChangeRequisite: (
      data: OrderChangeRequisite,
      params: RequestParams = {}
    ) =>
      this.request<OrderChangeRequisiteResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name GetOrderChangeRequisite
     * @summary Получение заявки на изменение реквизитов
     * @request GET:/api/deposits/v1/external/requisite/order/{orderId}
     * @secure
     */
    getOrderChangeRequisite: (orderId: string, params: RequestParams = {}) =>
      this.request<OrderChangeRequisiteResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name UpdateOrderChangeRequisite
     * @summary Изменение заявки на изменение реквизитов
     * @request POST:/api/deposits/v1/external/requisite/order/{orderId}
     * @secure
     */
    updateOrderChangeRequisite: (
      orderId: string,
      data: OrderChangeRequisiteUpdate,
      params: RequestParams = {}
    ) =>
      this.request<OrderChangeRequisiteResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order/${orderId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name DeleteOrderChangeRequisite
     * @summary Удаление заявки на изменение реквизитов
     * @request DELETE:/api/deposits/v1/external/requisite/order/{orderId}
     * @secure
     */
    deleteOrderChangeRequisite: (orderId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order/${orderId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Депозитные и балансовые продукты
     * @name DepositProductsPicker
     * @summary Подборщик депозитов
     * @request POST:/api/deposits/v1/external/product/picker
     * @secure
     */
    depositProductsPicker: (
      data: DepositProductPickerRequest,
      params: RequestParams = {}
    ) =>
      this.request<DepositProductPickerResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/product/picker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name UpdateOrder
     * @summary Обновление данных в заявке на депозит
     * @request POST:/api/deposits/v1/external/order/update
     * @secure
     */
    updateOrder: (
      query: { depositOrderId: string },
      data: OrderDepositRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/order/update`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name NewOrder
     * @summary Новая заявка на депозит
     * @request POST:/api/deposits/v1/external/order/create
     * @secure
     */
    newOrder: (data: OrderDepositRequest, params: RequestParams = {}) =>
      this.request<OrderDepositResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/order/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name CalculateRate
     * @summary Запрос на расчет ставки
     * @request POST:/api/deposits/v1/external/order/calculate-rate
     * @secure
     */
    calculateRate: (
      query?: { depositOrderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/order/calculate-rate`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name UpdateBalanceOrder
     * @summary Обновление данных в заявке на НСО/ФО
     * @request POST:/api/deposits/v1/external/balance/order/update
     * @secure
     */
    updateBalanceOrder: (
      query: { orderId: string },
      data: OrderBalanceRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/update`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name CreateBalanceOrder
     * @summary Новая заявка на НСО/ФО
     * @request POST:/api/deposits/v1/external/balance/order/create
     * @secure
     */
    createBalanceOrder: (
      data: OrderBalanceRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderBalanceResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name CalculateBalanceRate
     * @summary Запрос на расчет ставки
     * @request POST:/api/deposits/v1/external/balance/order/calculate-rate
     * @secure
     */
    calculateBalanceRate: (
      query?: { orderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/calculate-rate`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Депозиты клиента
     * @name PagedDepositList
     * @summary Получение постраничного списка депозитов
     * @request GET:/api/deposits/v2/external/deposit/list
     * @secure
     */
    pagedDepositList: (
      query: {
        isClosed: boolean;
        page?: number;
        size?: number;
        sort?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PagedModelDeposit, ErrorMessage>({
        path: `/api/deposits/v2/external/deposit/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ролевая модель
     * @name GetAvailableOperations
     * @summary Получение доступных бизнес операций
     * @request GET:/api/deposits/v1/external/role/available-operations
     * @secure
     */
    getAvailableOperations: (params: RequestParams = {}) =>
      this.request<AvailableBusinessOperationsResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/role/available-operations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на изменение реквизитов возврата суммы депозита и процентов
     * @name GetOrderRequisiteCcb
     * @summary ККБ заявки для смены реквизитов возврата
     * @request GET:/api/deposits/v1/external/requisite/order/ccb
     * @secure
     */
    getOrderRequisiteCcb: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/requisite/order/ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Депозитные и балансовые продукты
     * @name ListProducts
     * @summary Получение списка депозитных и балансовых продуктов
     * @request GET:/api/deposits/v1/external/product/list
     * @secure
     */
    listProducts: (params: RequestParams = {}) =>
      this.request<ProductList, ErrorMessage>({
        path: `/api/deposits/v1/external/product/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name GetOrder
     * @summary Информация по заявке на депозит
     * @request GET:/api/deposits/v1/external/order
     * @secure
     */
    getOrder: (query: { depositOrderId: string }, params: RequestParams = {}) =>
      this.request<OrderDeposit, ErrorMessage>({
        path: `/api/deposits/v1/external/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name UpdateOrderStatus
     * @summary Обновление статуса заявки на депозит
     * @request GET:/api/deposits/v1/external/order/update-status
     * @secure
     */
    updateOrderStatus: (
      query: { depositOrderId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/order/update-status`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name RequestPublicRate
     * @summary Запрос в публичную ставку
     * @request GET:/api/deposits/v1/external/order/public-rate
     * @secure
     */
    requestPublicRate: (params: RequestParams = {}) =>
      this.request<Rate, ErrorMessage>({
        path: `/api/deposits/v1/external/order/public-rate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name PrintTransferData
     * @summary Печатная форма реквизитов
     * @request GET:/api/deposits/v1/external/order/printTransferData
     * @secure
     */
    printTransferData: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/deposits/v1/external/order/printTransferData`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name PrintDepositOrder
     * @summary Печать подтверждения, либо отказа по заявке в виде PDF
     * @request GET:/api/deposits/v1/external/order/printConfirmationOrRefusal
     * @secure
     */
    printDepositOrder: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/deposits/v1/external/order/printConfirmationOrRefusal`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name ListOrders
     * @summary Список заявок на депозит
     * @request GET:/api/deposits/v1/external/order/list
     * @secure
     */
    listOrders: (params: RequestParams = {}) =>
      this.request<OrderDeposit[], ErrorMessage>({
        path: `/api/deposits/v1/external/order/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags История статусов
     * @name History
     * @summary Получение истории статусов заявки
     * @request GET:/api/deposits/v1/external/order/history
     * @secure
     */
    history: (
      query: { orderId: string; productCode: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderStatusHistory[], ErrorMessage>({
        path: `/api/deposits/v1/external/order/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие депозитов
     * @name DeleteOrder
     * @summary Удаление заявки на депозит
     * @request GET:/api/deposits/v1/external/order/delete
     * @secure
     */
    deleteOrder: (
      query: { depositOrderId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/order/delete`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Метод, вызываемый при входе пользователя в систему
     * @name PrepareClientData
     * @summary Запуск процесса синхронизации данных клиента
     * @request GET:/api/deposits/v1/external/init/prepare-client-data
     * @secure
     */
    prepareClientData: (params: RequestParams = {}) =>
      this.request<ClientData, ErrorMessage>({
        path: `/api/deposits/v1/external/init/prepare-client-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Метод, вызываемый при входе пользователя в систему
     * @name GetWorkingDay
     * @summary Получить информацию о рабочем статусе даты
     * @request GET:/api/deposits/v1/external/init/next-working-day
     * @secure
     */
    getWorkingDay: (query: { closeDate: string }, params: RequestParams = {}) =>
      this.request<WorkingDate, ErrorMessage>({
        path: `/api/deposits/v1/external/init/next-working-day`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы работы с ЕСД
     * @name CheckEsd
     * @summary Проверка наличия ЕСД
     * @request GET:/api/deposits/v1/external/esd/check-esd
     * @secure
     */
    checkEsd: (params: RequestParams = {}) =>
      this.request<ClientData, ErrorMessage>({
        path: `/api/deposits/v1/external/esd/check-esd`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Депозиты клиента
     * @name ListDeposits
     * @summary Получение списка депозитов
     * @request GET:/api/deposits/v1/external/deposit/list
     * @secure
     */
    listDeposits: (params: RequestParams = {}) =>
      this.request<Deposit[], ErrorMessage>({
        path: `/api/deposits/v1/external/deposit/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Депозиты клиента
     * @name DepositDetailInfo
     * @summary Получение детальной информации по депозиту
     * @request GET:/api/deposits/v1/external/deposit/info
     * @secure
     */
    depositDetailInfo: (
      query: { depositId: string },
      params: RequestParams = {}
    ) =>
      this.request<DepositDetailInfo, ErrorMessage>({
        path: `/api/deposits/v1/external/deposit/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetOrderCcb
     * @summary Ккб заявки на депозит
     * @request GET:/api/deposits/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (
      query: { depositOrderId: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/deposits/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/deposits/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name GetBalanceOrder
     * @summary Информация по заявке на НСО/ФО
     * @request GET:/api/deposits/v1/external/balance/order
     * @secure
     */
    getBalanceOrder: (query: { orderId: string }, params: RequestParams = {}) =>
      this.request<OrderBalance, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name UpdateStatus
     * @summary Обновление статуса заявки на НСО/ФО
     * @request GET:/api/deposits/v1/external/balance/order/update-status
     * @secure
     */
    updateStatus: (query: { orderId: string }, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/update-status`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name PrintBalanceOrder
     * @summary Печать подтверждения, либо отказа по заявке в виде PDF
     * @request GET:/api/deposits/v1/external/balance/order/printConfirmationOrRefusal
     * @secure
     */
    printBalanceOrder: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/printConfirmationOrRefusal`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name ListBalanceOrders
     * @summary Список заявок на НСО/ФО
     * @request GET:/api/deposits/v1/external/balance/order/list
     * @secure
     */
    listBalanceOrders: (params: RequestParams = {}) =>
      this.request<Deposit[], ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name GetBalanceOrderCcb
     * @summary ККБ заявки на НСО/ФО
     * @request GET:/api/deposits/v1/external/balance/order/ccb
     * @secure
     */
    getBalanceOrderCcb: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета клиента
     * @name ListAccounts
     * @summary Получение счетов клиента по статусу
     * @request GET:/api/deposits/v1/external/account/list
     * @secure
     */
    listAccounts: (
      query: { status: "OPEN" | "CLOSE" | "BLOCK" },
      params: RequestParams = {}
    ) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/deposits/v1/external/account/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на неснижаемый / фактический остаток
     * @name DeleteBalanceOrder
     * @summary Удаление заявки на НСО/ФО
     * @request DELETE:/api/deposits/v1/external/balance/order/delete
     * @secure
     */
    deleteBalanceOrder: (
      query: { orderId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/deposits/v1/external/balance/order/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
